import { render } from "./EnrolleeStatusEditSpouseOnboardComponent.vue?vue&type=template&id=0b6a39d2&scoped=true"
import script from "./EnrolleeStatusEditSpouseOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeStatusEditSpouseOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeStatusEditSpouseOnboardComponent.vue?vue&type=style&index=0&id=0b6a39d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6a39d2"]])

export default __exports__